// components/Tables/BillingTable.js
import React from 'react';

const BillingTable = ({ data = [] }) => {
  return (
    <div className="table-responsive">
      <table className="table table-history mb-0">
        <thead>
          <tr>
            <th>Садочок</th>
            <th>Група</th>
            <th>Табельний номер</th>
            <th>Тариф</th>
            <th>Нараховано</th>
            <th>До оплати</th>
          </tr>
        </thead>
        <tbody>
          {data.map((bill, index) => (
            <tr key={index}>
              <td>{bill.kg_number}</td>
              <td>{bill.group}</td>
              <td>{bill.tab}</td>
              <td>{bill.tarif}</td>
              <td>{bill.charged}</td>
              <td>{bill.to_payd}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BillingTable;